module.exports = __webpack_public_path__ + "img/IMG-20200226-WA0008.9fa0464a.jpg";